// js
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../common/Tooltip';


const ConfiguredItemColumnHeader = ({ flex, label, tooltip }) => {

  const content = tooltip ? (
    <Tooltip position='top' text={tooltip}>
      <label>{label}</label>
    </Tooltip>
  ) : (
    <label>{label}</label>
  );

  return (
    <div style={{ flex }} className='sources-stack-item__configured-item-column-header'>
      {content}
    </div>
  );
};

ConfiguredItemColumnHeader.propTypes = {
  flex: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string
};

export default ConfiguredItemColumnHeader;



// WEBPACK FOOTER //
// ./src/components/sources/ConfiguredItemColumnHeader.js